import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import the AuthProvider
import { AuthProvider } from './contexts/AuthContext';

// Import components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/admin/AdminLayout';

// Import pages
import Home from './pages/Home';
import About from './pages/About';
import ForCreators from './pages/ForCreators';
import Login from './pages/Login';
import CreatorDashboard from './pages/CreatorDashboard';
import PodcastManagement from './pages/PodcastManagement';
import PodcastImport from './pages/PodcastImport';
import MigrationPage from './pages/MigrationPage';
import Dashboard from './pages/Dashboard';

import SubscriptionPlans from './pages/SubscriptionPlans';
import Checkout from './pages/Checkout';
import SubscriptionSuccess from './pages/SubscriptionSuccess';
import SubscriptionManagement from './pages/SubscriptionManagement';
import PodcastDetailManagement from './pages/PodcastDetailManagement';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/for-creators" element={<ForCreators />} />
              <Route path="/login" element={<Login />} />
              <Route path="/migration" element={<MigrationPage />} />
              
              {/* Admin Routes - No Navbar/Footer */}
              <Route path="/admin/*" element={<AdminLayout />} />
              
              <Route path="/creator-dashboard" element={
                <ProtectedRoute requireCreator={true}>
                  <CreatorDashboard />
                </ProtectedRoute>
              } />
              <Route path="/podcast-management" element={
                <ProtectedRoute requireCreator={true}>
                  <PodcastManagement />
                </ProtectedRoute>
              } />
              <Route path="/podcast/import" element={
                <ProtectedRoute>
                  <PodcastImport />
                </ProtectedRoute>
              } /> 
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/subscribe" element={<SubscriptionPlans />} />
              <Route path="/checkout/:planId" element={
                <ProtectedRoute>
                  <Checkout />
                </ProtectedRoute>
              } />
              <Route path="/subscription/success" element={
                <ProtectedRoute>
                  <SubscriptionSuccess />
                </ProtectedRoute>
              } />
              <Route path="/subscription/manage" element={
                <ProtectedRoute>
                  <SubscriptionManagement />
                </ProtectedRoute>
              } />
              <Route path="/podcast/:podcastId/manage" element={
                <ProtectedRoute requireCreator={true}>
                  <PodcastDetailManagement />
                </ProtectedRoute>
              } />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;